import { FormKeys } from '@/features/settings/components/NotificationConfiguration/form/constants'
import { z } from 'zod'

const settingSchema = z.object({
    enabled: z.boolean(),
    sound: z.boolean(),
})

export const schema = z.object({
    [FormKeys.OrderAwaitingAcceptance]: settingSchema,
    [FormKeys.OrderAccepted]: settingSchema,
})
